import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=9c53cf1e&"
import script from "./RegisterCard.vue?vue&type=script&lang=ts&"
export * from "./RegisterCard.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports